/**
 * Utility functions for menu display
 */

import { OrderStatus } from '../types/menu';

/**
 * Get color for order status badge
 */
export const getStatusColor = (status: OrderStatus | string): string => {
    switch (status) {
        case 'pending': return '#FFA500';
        case 'acknowledged': return '#4169E1';
        case 'preparing': return '#1E90FF';
        case 'ready': return '#32CD32';
        case 'completed': return '#888';
        case 'cancelled': return '#FF6B6B';
        default: return '#888';
    }
};

/**
 * Get human-readable label for order status
 */
export const getStatusLabel = (status: OrderStatus | string): string => {
    switch (status) {
        case 'pending': return 'Pending';
        case 'acknowledged': return 'Acknowledged';
        case 'preparing': return 'Preparing';
        case 'ready': return 'Ready';
        case 'completed': return 'Completed';
        case 'cancelled': return 'Cancelled';
        default: return status;
    }
};

/**
 * Format time relative to now (e.g., "5 min ago")
 */
export const formatTime = (dateString: string): string => {
    const date = new Date(dateString);
    const now = new Date();
    const diff = Math.floor((now.getTime() - date.getTime()) / 60000); // minutes

    if (diff < 1) return 'Just now';
    if (diff < 60) return `${diff} min ago`;

    return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
};

/**
 * Format price for display
 */
export const formatPrice = (price: number, currency: string = 'RWF'): string => {
    return `${Math.round(price).toLocaleString()} ${currency}`;
};
